import axios from "axios";
import { apiErrorHandler } from "./helper/handler";

const prefix = "report";

const GET_USER_REPORT_URL = `${prefix}/user-mobile-report`;
const GET_APPOINTMENT_REPORT_URL = `${prefix}/appointment-report`;
const EXPORT_USER_MOBILE_REPORT_URL = `${prefix}/export-user-mobile-report`;
const EXPORT_APPOINTMENT_REPORT_URL = `${prefix}/export-appointment-report`;

/**
 * @func getUserMobileReport
 * @desc get all user mobile data
 * @author jew
 * @param {AbortSignal} signal - AbortController Signal
 * @returns {Array} user mobile array
 */
export const getUserMobileReport = async (queryParams, signal) => {
    try {
        const { data, status } = await axios.get(GET_USER_REPORT_URL, {
            params: queryParams,
            signal,
        });
        if (status === 200) {
            return data;
        }
        return undefined;
    } catch (error) {
        const err = apiErrorHandler(error, "getUserMobileReport");
        if (err) throw err;
        return undefined;
    }
};
/** End @func getUserMobileReport */

/**
 * @func getAppointmentReport
 * @desc get all appointment data
 * @author jew
 * @param {AbortSignal} signal - AbortController Signal
 * @returns {Array} appointment array
 */
export const getAppointmentReport = async (queryParams, signal) => {
    try {
        const { data, status } = await axios.get(GET_APPOINTMENT_REPORT_URL, {
            params: queryParams,
            signal,
        });
        if (status === 200) {
            return data;
        }
        return undefined;
    } catch (error) {
        const err = apiErrorHandler(error, "getAppointmentReport");
        if (err) throw err;
        return undefined;
    }
};
/** End @func getAppointmentReport */

/**
 * @func exportUserMobileReport
 * @desc export user mobile report data
 * @author izeberg
 * @param {AbortSignal} signal - AbortController Signal
 * @returns {Array} user mobile report array
 */
export const exportUserMobileReport = async (queryParams, signal) => {
    try {
        const { data, status } = await axios.get(EXPORT_USER_MOBILE_REPORT_URL, {
            params: queryParams,
            signal,
        });
        if (status === 200) {
            return data;
        }
        return undefined;
    } catch (error) {
        const err = apiErrorHandler(error, "exportUserMobileReport");
        if (err) throw err;
        return undefined;
    }
};
/** End @func exportUserMobileReport */

/**
 * @func exportAppointmentReport
 * @desc export appointment report data
 * @author izeberg
 * @param {AbortSignal} signal - AbortController Signal
 * @returns {Array} appointment report array
 */
export const exportAppointmentReport = async (queryParams, signal) => {
    try {
        const { data, status } = await axios.get(EXPORT_APPOINTMENT_REPORT_URL, {
            params: queryParams,
            signal,
        });
        if (status === 200) {
            return data;
        }
        return undefined;
    } catch (error) {
        const err = apiErrorHandler(error, "exportAppointmentReport");
        if (err) throw err;
        return undefined;
    }
};
/** End @func exportAppointmentReport */